@if (!isAdminArea()) {
  <app-site-header />
}
@if (!isAdminArea() && breadcrumbTrail().length > 1) {
  <app-breadcrumb [items]="breadcrumbTrail()" />
}
<main class="page-wrapper">
  <div class="page-content" [class.page-content--hidden]="!pageVisible()">
    <router-outlet />
  </div>
</main>
@if (!isAdminArea()) {
  <app-footer />
}
<app-search-overlay />
